var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 671,
    height: 573,
    viewBox: "0 0 671 573",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.584 4.00088C636.848 -11.2681 675.724 19.3962 669.321 58.2192L593.691 516.776C586.398 560.99 537.838 586.359 497.274 564.326C463.331 545.889 412.971 517.513 367.584 487.856C344.921 473.046 275.524 425.56 284.054 391.756C291.348 362.853 408.011 254.256 474.678 189.673C500.864 164.304 488.938 149.648 458.011 173.006C381.291 230.95 258.118 319.046 217.386 343.84C181.449 365.713 162.685 369.446 140.303 365.713C99.432 358.903 61.5397 348.356 30.6037 335.533C-11.2087 318.2 -9.17199 260.74 30.5753 244.006L600.584 4.00088Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.a731e87780d07ac68675f85f627a95b5.svg";
export { ForwardRef as ReactComponent };